import { reactive } from 'vue'

export const confirmDialogState = reactive({
  visible: false,
  message: '',
  variant: 'default',
  confirmLabel: '',
  cancelLabel: '',
})

let resolvePromise = null

export function handleConfirm() {
  confirmDialogState.visible = false
  if (resolvePromise) {
    resolvePromise(true)
    resolvePromise = null
  }
}

export function handleCancel() {
  confirmDialogState.visible = false
  if (resolvePromise) {
    resolvePromise(false)
    resolvePromise = null
  }
}

function confirm({ message, variant = 'default', confirmLabel = '', cancelLabel = '' } = {}) {
  confirmDialogState.message = message
  confirmDialogState.variant = variant
  confirmDialogState.confirmLabel = confirmLabel
  confirmDialogState.cancelLabel = cancelLabel
  confirmDialogState.visible = true
  const { promise, resolve } = Promise.withResolvers()
  resolvePromise = resolve
  return promise
}

export function useConfirmDialog() {
  return { confirm }
}
